import React, { useState, useEffect } from 'react'
import { Box, Flex, Button } from '@mantine/core'
import ReactPlayer from 'react-player'
import {
  MediaController,
  MediaControlBar,
  MediaTimeRange,
  MediaTimeDisplay,
  MediaVolumeRange,
  MediaPlaybackRateButton,
  MediaPlayButton,
  MediaSeekBackwardButton,
  MediaSeekForwardButton,
  MediaMuteButton,
  MediaFullscreenButton,
} from "media-chrome/react"



const PreviewVideoProduct = ({ detailVideo, onCloseForm }) => {
  const [videoUrl, setVideoUrl] = useState('')

  useEffect(() => {
    if (detailVideo) {
      setVideoUrl(detailVideo.link_embed)
    }
  }, [detailVideo])

  if (videoUrl !== '') {
    return (
      <Box>
        <MediaController
          style={{
            width: "100%",
            aspectRatio: "16/10",
            borderRadius: "12px",
            border: "1px solid #e1e1e1",
            overflow: "hidden",
          }}
        >
          <ReactPlayer
            src={videoUrl}
            controls={false}
            config={{
              youtube: {
                embedOptions: {
                  referrerPolicy: 'strict-origin-when-cross-origin'
                }
              }
            }}
            style={{
              width: "100%",
              height: "100%",
              "--controls": "none",
            }}
          />
          <MediaControlBar>
            <MediaPlayButton />
            <MediaSeekBackwardButton seekOffset={10} />
            <MediaSeekForwardButton seekOffset={10} />
            <MediaTimeRange />
            <MediaTimeDisplay showDuration />
            <MediaMuteButton />
            <MediaVolumeRange />
            <MediaPlaybackRateButton />
            <MediaFullscreenButton />
          </MediaControlBar>
        </MediaController>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
          </Flex>
        </Box>
      </Box>
    )
  }
}

export default PreviewVideoProduct